import z from'zod';/**
 * Represents a custom emoji.
 * https://docs.joinmastodon.org/entities/CustomEmoji/
 */var customEmojiSchema=z.object({category:z.string().catch(''),shortcode:z.string(),static_url:z.string().catch(''),url:z.string(),visible_in_picker:z.boolean().catch(true)});export{customEmojiSchema};